import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Alert from "@material-ui/lab/Alert/Alert";
import OfferContactInformation from "./OfferContactInformation";

const useStyles = makeStyles((theme) => {
    return {
        root: {
            marginBottom: 20,
            border: '1px dotted #ccc',
            padding: 15,
        },
        header: {
            marginTop: 15
        },
        headerMobile: {
            marginBottom: 5
        },
        subHeader: {
            marginBottom: 5
        },
        subHeaderMobile: {
            marginBottom: 10
        }
    }
});

export default function OfferContactInformationWrapper(props) {

    const classes = useStyles();
    const isMobile = props.isMobile;
    const request = props.request;
    const [closed, setClosed] = React.useState();
    const [actionComplete, setActionComplete] = React.useState();

    const onClosed = () => {
        setClosed(true);
    };

    if (closed) {
        return null;
    }

    const onActionComplete = () => {
       if (!actionComplete) {
           props.onActionComplete();
           setActionComplete(true);
       }
    };

    if (request.contactsProvided && !actionComplete) {
        return null;
    }

    return <>
            {actionComplete ? <Alert severity="success" onClose={onClosed}>Thank you! Your contact details has been received.</Alert> :
            <>
                <OfferContactInformation request={request} onActionComplete={onActionComplete}/>
            </>
        }
    </>;
}
